module.exports = __webpack_public_path__ + "img/groupuser.65a95c38.png";